import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lastpass = defineConnector({
  identifier: "lastpass",
  name: "LastPass",
  tagLine: "Password and identity management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://lastpass\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Find your LastPass API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [LastPass Enterprise API getting started guide](https://developer.lastpass.com/docs/enterprise-api/getting-started/) and create API credentials for your LastPass Enterprise account. Copy the integration username and password or API secret that LastPass issues.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your LastPass account settings.",
        },
        {
          kind: "input",
          label: "CID",
          required: true,
          target: { kind: "secrets", field: "username" },
          helperText: "Your LastPass Account number",
        },
        {
          kind: "input",
          label: "Provhash",
          required: true,
          target: { kind: "secrets", field: "password" },
          helperText: "Your LastPass API key",
        },
      ],
    },
  ],
  connectionTest: { protocol: "http", request: () => "https://lastpass.com/" },
});
